import axios from 'axios';
import Cookies from 'universal-cookie';
import { auth } from '../firebase-init';

const cookies = new Cookies();
const AxiosInstance = axios.create({
  baseURL: '/api/',
});

AxiosInstance.interceptors.request.use(
  async (config) => {
    if (auth.currentUser) {
      const token = await auth.currentUser.getIdToken();
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response.data);
    }),
  (error) => {
    if (error.response.status === 401) {
      // cookies.remove('access_token', { path: '/' });
      return new Promise((resolve, reject) => {
        reject({
          status: error.response.status,
          data: 'ERROR_NOT_ATHORIZED',
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        reject({
          status: error.response.status,
          data: error.response.data,
        });
      });
    }
  }
);

export default AxiosInstance;
